// import { defineNuxtPlugin } from 'nuxt/app';
// import api from '~/utils/api';
// import musicService from '~/services/musicService';
// import loginService from '~/services/login';

import { initApiClient } from '~/utils/api';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  
  // 初始化 API 客户端
  const apiBaseUrl = config.public.apiBaseUrl as string;
  
  // 如果没有配置 API 基础 URL，使用默认值
  const baseUrl = apiBaseUrl || 'https://server.musicmint.ai';

  console.log('apiBaseUrl: %s, baseUrl: %s', apiBaseUrl, baseUrl);
  
  // 初始化 API 客户端
  initApiClient(baseUrl);
}); 